import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { AccountService } from '../../shared/services/account.service';
import { AppService } from "../../shared/services/app.service";
import { Router, ActivatedRoute } from '@angular/router';
import { LanguageService } from '../../shared/services/language.service';
import { DOCUMENT } from '@angular/common';
import {DomSanitizer,SafeResourceUrl,} from '@angular/platform-browser';

declare var $: any; import {isBrowser} from '../../shared/thirdparty/isBrowser'
declare var Swal:any;

@Component({
  selector: 'app-digital-learning',
  templateUrl: './digital-learning.component.html',
  styleUrls: ['./digital-learning.component.scss']
})
export class DigitalLearningComponent implements OnInit {

  constructor(
      public accountService : AccountService,
      public appService : AppService,
      public router : Router,
      public language : LanguageService,
      public sanitizer:DomSanitizer,
      @Inject(DOCUMENT) public document: Document
  ) { }

public videoSrc : SafeResourceUrl;


  ngOnInit() {
      if(isBrowser() && $('video') && $('video').length){
          for (let i = 0; i<$('video').length; i++) {
              $('video')[i].muted = true;
              $('video')[i].load();
          }
      }
      this.videoSrc = this.sanitizer.bypassSecurityTrustResourceUrl("");
      // stop playing the youtube video when we close the modal
      //$('#exampleModalCenter').on('hide.bs.modal', function (e) {
          // we stop the video
      //    $("#video").attr('src','');
      //})

  }

  video(url){
    this.videoSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url+"?autoplay=1&amp;modestbranding=1&amp;showinfo=0");

    var modal = document.querySelector(".modal");
    var container = modal.querySelector(".modal-content");

    // Check if we click outside the modal in order to stop the video
    document.querySelector(".modal").addEventListener("click", function (e) {
      if (e.target !== container){
        document.getElementById("video").setAttribute('src', '');
      }
    });

  }

  freeAccess(){
      this.router.navigate(this.language.navigateAccordingToLang(['/demo']))
  }

}
